import api from '@/api';
import { ActivatePayoutAccountRequest } from '@/types/api/payout-account';
import notify from '@/utils/shared/notify';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useActivatePayoutAccountMutation() {
  const queryClinet = useQueryClient();

  return useMutation<void, Error, ActivatePayoutAccountRequest>({
    mutationKey: ['activate-payout-account'],
    mutationFn: (data) => api.payoutAccount.activate(data),
    onSuccess: () => {
      notify.success('Utbetalningskonto bytt!');
      queryClinet.invalidateQueries({
        queryKey: ['payout-accounts'],
      });
    },
  });
}
